/// <reference path="../types.d.ts" />
export { default as Modal } from './modal';
export type { ModalProps } from './types';
